const FIELDS = [
  "device_code",
  "location_id",
  "location_name",
  "hostname",
  "device_uid",
  "tablet_serial",
  "manufacturer",
  "model",
  "teamviewer_id",
  "os_version",
  "agent_version",
  "status",
  "first_seen",
  "last_seen",
];

function esc(v) {
  const s = v == null ? "" : String(v);
  if (/[",\n;]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function exportDevicesCsv(devices) {
  const extraKeys = Array.from(
    new Set(devices.flatMap((d) => (d.extra ? Object.keys(d.extra) : [])))
  ).sort();
  const cols = [...FIELDS, ...extraKeys.map((k) => `extra.${k}`)];
  const header = cols.join(";");
  const rows = devices.map((d) =>
    cols
      .map((c) => (c.startsWith("extra.") ? esc((d.extra || {})[c.slice(6)]) : esc(d[c])))
      .join(";")
  );
  const csv = "\uFEFF" + [header, ...rows].join("\n");
  downloadBlob(csv, `fleet-devices-${new Date().toISOString().slice(0, 10)}.csv`, "text/csv;charset=utf-8");
}

export function downloadBlob(content, filename, type) {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
